import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { nextTick, ref, withDefaults } from 'vue';
import Tooltip from '../tooltip/Tooltip.vue';
import { popperTooltip } from '@/helpers/popper';
import { Placement } from '@popperjs/core';

interface Props {
  color?: 'danger'|'primary';
  tooltipMessage?: string|string[];
  tooltipPlacement?: Placement;
  icon?: string;
  small?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Mark',
  props: {
    color: { default: 'danger' },
    tooltipMessage: { default: '' },
    tooltipPlacement: null,
    icon: { default: 'exclamation' },
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { color: 'danger'|'primary', tooltipMessage: string|string[], tooltipPlacement?: Placement, icon: string, small?: boolean }



const hovered = ref<boolean>(false);

const markRef = ref<HTMLElement|undefined>(undefined);
const tooltipRef = ref<InstanceType<typeof Tooltip>|undefined>(undefined);

function mouseEnter() {
  hovered.value = true;
  nextTick(() => {
    const mark = markRef.value;
    const tooltip = tooltipRef.value;

    if (mark && tooltip) {
      popperTooltip(mark, tooltip.$el, props.tooltipPlacement);
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "markRef",
    ref: markRef,
    class: _normalizeClass(["mark", [`col-${__props.color}`, {small: __props.small}]]),
    onMouseenter: mouseEnter,
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hovered.value = false))
  }, [
    _createVNode(_component_FontAwesomeIcon, { icon: __props.icon }, null, 8, ["icon"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (hovered.value)
            ? (_openBlock(), _createBlock(Tooltip, {
                key: 0,
                ref_key: "tooltipRef",
                ref: tooltipRef,
                class: "tooltip",
                message: __props.tooltipMessage
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 34))
}
}

})